import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmModalActionsVm } from 'src/app/models/modal-actions/confirm-modal-action';
import { GoogleTagManagerService } from 'src/app/services/google-analytics/google-tag-manager.service';
import * as strings from './calc-unsaved-changes-modal.component.strings';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { ModalIconsComponent } from '../modal-icons/modal-icons.component';

@Component({
    selector: 'app-calc-unsaved-changes-modal',
    templateUrl: './calc-unsaved-changes-modal.component.html',
    styleUrls: ['./calc-unsaved-changes-modal.component.scss'],
    imports: [BaseModalComponent, ModalIconsComponent]
})
export class CalcUnsavedChangesModalComponent implements OnInit {
    public modalActions: ConfirmModalActionsVm = new ConfirmModalActionsVm();
    public s = strings;
    
    @Input() set inputs(value: ConfirmModalActionsVm) {
        this.modalActions = value;
    }

    constructor(
        public activeModal: NgbActiveModal,
        private googleTagManagerService: GoogleTagManagerService,
    ) { }

    ngOnInit(): void {
        this.googleTagManagerService.trackAction(this.s.GoogleTagManagerEvent, this.s.GoogleTagManagerPopUpOpenAction, undefined, this.s.GoogleTagManagerName);
    }

    onCustomAction() {
        this.modalActions.customAction();
        this.googleTagManagerService.trackAction(this.s.GoogleTagManagerEvent, this.s.GoogleTagManagerSubmittedAction, undefined, this.s.GoogleTagManagerName);
    }

    onCustomCloseAction() {
        this.modalActions.customCloseAction();
        this.googleTagManagerService.trackAction(this.s.GoogleTagManagerEvent, this.s.GoogleTagManagerPopUpCloseAction, undefined, this.s.GoogleTagManagerName);
    }
}
